import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "code",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme"])
  },
  data() {
    return {
      popGetAwaitShow: false
    };
  },
  beforeRouteLeave(to, from, next) {
    this.popGetAwaitShow = false;
    this.$nextTick(() => {
      next();
    });
  },
  methods: {
    onClaim() {
      this.popGetAwaitShow = true;
    }
  }
};